import request from '@/utils/http'

const BASE_URL = "https://204910013.xyz/";
// const BASE_URL = "http://localhost:8080/";

// 注册
export const registerByUsername = (registerForm) => {
    return request.requestPost(BASE_URL+"portal/user/registerByUsername",registerForm);
};

// 登录方法
export function loginByUsername(username, password) {
    const data = {
        username,
        password,
    }
    return request.requestPost(BASE_URL+'portal/user/loginByUsername', data)
}

// 获取用户详细信息
export function getUserInfo(token) {
    return request.requestPost(BASE_URL+'portal/user/getUserInfo?token='+token)
}

// 获取用户详细信息
export function updateUserInfo(user) {
    return request.requestPost(BASE_URL+'portal/user/updateUserInfo',user)
}

// 退出方法
export function logout() {
    return request({
        url: '/logout',
        method: 'post'
    })
}

// 获取验证码
export function getCodeImg() {
    return request({
        url: '/captchaImage',
        method: 'get'
    })
}
